import { default as ByteChunksView, ReadonlyByteChunksView } from '../byteChunksView';
import { byteChunksToInt } from '../utils';
import PngChunkView from './pngChunkView';

export default class FrameDataChunkView extends PngChunkView
{
    private readonly rawSequenceNumber: ByteChunksView;
    private readonly rawFrameData: ByteChunksView;

    constructor(rawData: Uint8Array[])
    {
        super(rawData);
        [this.rawSequenceNumber, this.rawFrameData] = this.rawContent.split(4);
    }

    /**
     * sequence number of the animation chunk, starting from 0.
     */
    get sequenceNumber(): number
    {
        return byteChunksToInt(this.rawSequenceNumber.getRawChunks());
    }

    get frameData(): ReadonlyByteChunksView
    {
        return this.rawFrameData;
    }
}
